function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "heart-path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.694-1.46c.7.027,5.565-3.226,7.028-6.487a5.33,5.33,0,0,0,0-5.18A4.234,4.234,0,0,0,11.138-15c-2.128,0-3,2.138-3.445,2.138S6.48-15,4.249-15A4.234,4.234,0,0,0,.668-13.128a5.33,5.33,0,0,0,0,5.18C2.129-4.687,7-1.487,7.694-1.46Z",
  transform: "translate(0 15)",
  fill: "none",
  clipRule: "evenodd"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-31 -107)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  transform: "translate(31 107)",
  fill: "#e03e25"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(38 116)",
  clipPath: "url(#heart-path)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-5-20H19.438V2.591H-5Z",
  transform: "translate(0.474 15.474)",
  fill: "#fff"
})));

var SvgReactionHeart = function SvgReactionHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReactionHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reaction-heart.7e5aba33.svg";
export { ForwardRef as ReactComponent };